// extracted by mini-css-extract-plugin
module.exports = {"container":"tournamentItemWrapper__container___K4s0t","arrow-icon":"tournamentItemWrapper__arrow-icon___1AXvu"};